var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8233 4.32712C22.3039 4.82002 22.3039 5.61626 21.8233 6.10917L19.5682 8.42205L14.9472 3.68254L17.2022 1.36966C17.4325 1.133 17.745 1 18.071 1C18.397 1 18.7095 1.133 18.9398 1.36966L21.8233 4.32712ZM0 23.1209V19.2788C0 19.1018 0.0616136 18.9502 0.184841 18.8238L13.6289 5.03497L18.2499 9.77447L4.79354 23.5633C4.68263 23.6897 4.52244 23.7529 4.36224 23.7529H0.616136C0.2711 23.7529 0 23.4748 0 23.1209Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.35205,
    y: 22.0047,
    width: 15.6479,
    height: 1.56479,
    rx: 0.782395
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.bdbd5677.svg";
export { ForwardRef as ReactComponent };